import { passwordResetService } from '../../helpers/services/passwordReset.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'
import { filtersHelper } from "@/utils";

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  details: {},
  status: {}
}

export const PASSWORD_RESET_MODULE = "passwordReset";

// define action 
export const GET_ALL_PASSWORD_RESET = 'getAllPasswordReset';
export const RESEND = 'resend';

// define mutation
const ALL_PASSWORD_RESET_REQUEST = "allPasswordResetRequest";

export const actions = {

  // eslint-disable-next-line no-unused-vars
  [GET_ALL_PASSWORD_RESET]({ commit }, { filter }) {
    passwordResetService
      .getAllPasswordReset(filter)
      .then(
        (result) => {
          commit(ALL_PASSWORD_RESET_REQUEST, { data: result })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
        }
      )
  },

  // eslint-disable-next-line no-unused-vars
  [RESEND]({ dispatch, commit }, { data }) {
    passwordResetService.resend(data)
      .then(
        // eslint-disable-next-line no-unused-vars
        (result) => {
          var message = i18n.t('message.resendXSuccess', [i18n.t('label.email')])
          sharedHelper.alertSuccessMessage(message)
          dispatch(GET_ALL_PASSWORD_RESET, { data })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
        }
      )
  },

};

export const mutations = {
  [ALL_PASSWORD_RESET_REQUEST](state, { data }) {
    let d = data.data

    state.list.data = []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

    if (data.success) {
      let list = []

      d.forEach((o) => {
        var createdAt = filtersHelper.getDateTimeFormat(o.created_at);
        list.push({
            email: o.email,
            purpose: o.purpose,
            token: o.token,
            userType: o.user_type,
            isUsed: o.is_used,
            createdAt: createdAt,
            name: o.user.name,
        })
      })

      state.list.data = list
    }
  },
}


